export default "__VITE_ASSET__n86EVOgn__"